import React, { useMemo, useState, JSX } from 'react';
import { SessionStorageType } from './Search';
import ResultList from './ResultList';
import { ApiProductCard } from '../../api';
import ProductsSearchForm from './ProductsSearchForm';
import { PackageParams } from '@ibe/components';
import { ApiGetPackagesResponse } from '@ibe/api';
import { productItemListEvent } from '../Tracking/events';
import { useMount } from 'react-use';

const ProductContainer = ({
  sessionProp,
  setSessionProp
}: {
  sessionProp?: SessionStorageType;
  setSessionProp: (sessionStorage: SessionStorageType | undefined) => void;
}): JSX.Element => {
  const [localProductResultItems, setLocalProductResultItems] = useState<ApiProductCard[]>([]);

  useMount(() => {
    // Needed when the user clicks the back button or reloads the page, to fire the event again
    if (!new URLSearchParams(globalThis.location.search).get('searchTerm')) {
      productItemListEvent.broadcast({ items: resultItems });
    }
  });

  const handleSubmit = (resultItems: ApiProductCard[]): void => {
    setLocalProductResultItems(resultItems);
    if (resultItems) {
      productItemListEvent.broadcast({ items: resultItems });
    }
    setSessionProp(undefined);
  };

  const resultItems = useMemo(
    () =>
      localProductResultItems && localProductResultItems.length > 0
        ? localProductResultItems
        : (sessionProp?.list as ApiProductCard[]),
    [sessionProp, localProductResultItems]
  );

  return (
    <div className="search-list">
      <ProductsSearchForm
        onPackagesLoaded={(
          search: string | PackageParams,
          list: (ApiGetPackagesResponse | null) | ApiProductCard[]
        ) => handleSubmit(list as ApiProductCard[])}
        search={sessionProp?.search}
      />
      {!!resultItems && resultItems.length > 0 && <ResultList productResultItems={resultItems} />}
    </div>
  );
};

export default ProductContainer;
